import script from "./ProductCategoryGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategoryGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__